(function () {
  'use strict';

  function initReveals(scope) {
    var nodes = (scope || document).querySelectorAll('.profs-reveal:not([data-profs-bound])');
    if (!nodes.length) return;
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!prefersReduced && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('profs-is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      nodes.forEach(function (node) {
        node.setAttribute('data-profs-bound', '1');
        observer.observe(node);
      });
    } else {
      nodes.forEach(function (node) {
        node.setAttribute('data-profs-bound', '1');
        node.classList.add('profs-is-visible');
      });
    }
  }

  function initPackPickers(scope) {
    var pickers = (scope || document).querySelectorAll('[data-profs-pack-picker]:not([data-profs-bound])');
    pickers.forEach(function (root) {
      root.setAttribute('data-profs-bound', '1');
      var buttons = root.querySelectorAll('.profs-pack-choice');
      var stage = root.querySelector('[data-profs-pack-stage]');
      if (!stage || !buttons.length) return;
      var img = stage.querySelector('[data-profs-pack-image]');
      var nameEl = stage.querySelector('[data-profs-pack-name]');
      var priceEl = stage.querySelector('[data-profs-pack-price]');
      var linkEl = stage.querySelector('[data-profs-pack-link]');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          buttons.forEach(function (b) {
            b.classList.remove('profs-is-active');
            b.setAttribute('aria-selected', 'false');
          });
          btn.classList.add('profs-is-active');
          btn.setAttribute('aria-selected', 'true');
          if (img) img.classList.add('profs-is-swapping');
          window.setTimeout(function () {
            if (img) {
              img.src = btn.getAttribute('data-image') || img.src;
              img.alt = btn.getAttribute('data-alt') || btn.getAttribute('data-name') || '';
            }
            if (nameEl) nameEl.textContent = btn.getAttribute('data-name') || '';
            if (priceEl) priceEl.textContent = btn.getAttribute('data-price') || '';
            if (linkEl && btn.getAttribute('data-url')) linkEl.setAttribute('href', btn.getAttribute('data-url'));
            window.setTimeout(function () {
              if (img) img.classList.remove('profs-is-swapping');
            }, 200);
          }, 160);
        });
      });
    });
  }

  function initAll() {
    initReveals(document);
    initPackPickers(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initReveals(event.target);
    initPackPickers(event.target);
  });
})();
